/* beautiful-react-hooks version: 0.35.0 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var createHandlerSetter = function createHandlerSetter(handlerValue) {
  var handlerRef = react.useRef(handlerValue);
  var setHandler = react.useCallback(function (nextCallback) {
    if (typeof nextCallback !== 'function') {
      throw new Error('the argument supplied to the \'setHandler\' function should be of type function');
    }

    handlerRef.current = nextCallback;
  }, [handlerRef]);
  return [handlerRef, setHandler];
};

exports.default = createHandlerSetter;
